import { OrganizationsOutput } from "@/interfaces";
import { UsersOutput } from "@/interfaces/users";

// services/TokenManager.ts
export class AppManager {
  private static instance: AppManager;
  private token: string | null = null;
  private organizations: OrganizationsOutput[] = [];
  private actualOrganization: string | null = null;
  private user: UsersOutput | null = null;
  private actualPlanId: string = "";

  private constructor() {}

  // Método para obter a instância do singleton
  public static getInstance(): AppManager {
    if (!AppManager.instance) {
      AppManager.instance = new AppManager();
    }
    return AppManager.instance;
  }

  public setOrganizations(organizations: OrganizationsOutput[]) {
    this.organizations = organizations;
  }

  public setOrganizationId(actualOrganization: string): void {
    localStorage.setItem("selectedOrganizationId", actualOrganization);
    this.actualOrganization = actualOrganization;
  }

  public getActualPlanId(): string {
    if (this.actualPlanId) {
      return this.actualPlanId;
    }

    const actualPlan = localStorage.getItem("actualPlanId");
    if (actualPlan) {
      return actualPlan;
    }

    return this.actualPlanId;
  }

  public getActualOrganization(): string | null {
    if (this.actualOrganization) {
      return this.actualOrganization;
    }

    const organization = localStorage.getItem("selectedOrganizationId");
    if (organization) {
      return organization;
    }

    if (this.organizations?.length) {
      return this.organizations[0].id;
    }

    return null;
  }

  // Método para definir o token
  public setToken(token: string) {
    this.token = token;
  }

  // Método para recuperar o token
  public getToken(): string | null {
    return this.token;
  }

  // Método para limpar o token
  public clearToken() {
    this.token = null;
  }

  public setUser(user: UsersOutput) {
    this.user = user;
  }

  public getUser(): UsersOutput | null {
    return this.user;
  }

  public clearUser() {
    this.user = null;
  }
}
